import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsContent } from 'components/common/ns-content/NsContent';

export const personalInformationSummaryHeaderTestId =
  'personalInformationSummaryHeaderTestId';

const PersonalInformationSummaryHeader = () => {
  return (
    <NsContent data-testid={personalInformationSummaryHeaderTestId}>
      <NsBackCta />
      <h1>Here is what you&apos;ve told us so far</h1>
      <h5>
        Please check the information below is correct, so we can provide you
        with the best tariff option.{' '}
      </h5>
    </NsContent>
  );
};

export default PersonalInformationSummaryHeader;
